// extracted by mini-css-extract-plugin
module.exports = {"skill":"Skill_skill__1FbHI","hexa":"Skill_hexa__OTW1n","skill__description":"Skill_skill__description__2MPe-"};